export default __webpack_public_path__ + "f23ff1c0867776fc9e5162d928498c86.svg";